import React from 'react';
import GOTUtil from '../../utils/GOTUtil';
import FormLoadHelper from '../../utils/FormLoadHelper';
import Command from '../../remote/Command';
import ServiceHelper from '../../remote/ServiceHelper';
require('./style/TreeViewMainMenuStyle.css');
export default class TreeViewMainMenu extends React.Component
{
	constructor(props)
	{
		super(props);
		this.renderSub=this.renderSub.bind(this);
		this.menuItemClick = this.menuItemClick.bind(this);
		this.getLabelName=this.getLabelName.bind(this);
		this.platMainMenu = {};
	}

	menuItemClick(event)
	{
		this.doOpenMenuItem(event);
		//window.testOpenForm(_label,_formId,_menuItemId,_onlyQuery);
	}

	doOpenMenuItem(event)
	{
		var target = event.target;

		if(!$(target).hasClass("listtree-menu-title"))
		{
			target = $(target).parent();
		}

		if(!$(target).hasClass("listtree-menu-title"))
		{
			target = $(target).parent();
		}

		if(!$(target).hasClass("listtree-menu-title"))
		{
			return;
		}

		var _label = $(target).attr("data-formLabel");
		var _formId = $(target).attr("data-formId");
		var _menuItemId = $(target).attr("data-menuItemId");
		var _onlyQuery=$(target).attr("data-onlyQuery") == "true"?true:false;
		FormLoadHelper.openMenuItem({menuItemId:_menuItemId,onlyQuery:_onlyQuery,label:_label,checkHas:false,fromMainMenu:true});
	}

	menuItemClickSelect(event)
	{
		var target = event.target;
		$("#mainMenu a.selected").removeClass("selected");
		$(target).addClass("selected");
		
	}

	getLabelName(item){
		var label=GOTUtil.getPropertyValue(item,"Label");
      	if(label==""|!label){
      		label=item.name;
      	}
      	return label;
	}

	autoScrollbar() 
	{
		var jq = $(".mCSB_container");
		if (jq.parent().height() >= jq.children().outerHeight()) {
			jq.css("height", "100%");
		} else {
			jq.css("height", "auto");
		}
	}

	mouseenterHandler(event)
	{
		var jq = $(event.currentTarget);

		if (this.lostTimer) clearTimeout(this.lostTimer);

		$(".listtree-menu li").removeClass("listtree-menu-hover");

		jq.parent().addClass("listtree-menu-hover");

		//alert(1);

		//////////////////////////////////////////////////////////

		//top
		var ul = jq.next('ul');
		if (!ul[0]) return;

		ul.css("top", "");

		var viewHeight = $(window).height() - 1;
		var offset = ul.offset(),
			height = ul.outerHeight();

		var top = offset.top;

		if (top + height > viewHeight) {
			top = viewHeight - height;
			ul.offset({ left: 0, top: top });
			ul.css("left", "");
		}
	}

	mouseleaveHandler(event)
	{
		var jq = $(event.currentTarget);

		this.lostTimer = setTimeout(function () {
			jq.parent().removeClass("listtree-menu-hover");
		}, 200);
	}

	componentDidMount()
	{
		$(".listtree-sidebar").mCustomScrollbar({ autoHideScrollbar: false });

		
        $(window).on("resize", this.autoScrollbar.bind(this));
        this.autoScrollbar();

		var el = $("#listtree-mainMenu");

        var lostTimer;
		$(document.body).on("mouseenter", ".listtree-menu-title", this.mouseenterHandler.bind(this));

		$(document.body).on("mouseleave", ".listtree-menu-title", this.mouseleaveHandler.bind(this));
	}

	renderSub(items,moudleId)
	{	
		var content=[];
		
		if(items)
		{	
			for(var i=0;i<items.length;i++)
			{
				var item = items[i];

      			if(item.qname)
      			{
      				if(item.qname=="MenuItem")
      				{	
						if(!window.flatMainMenuToMenuItem.hasOwnProperty(item.id))
						{
							window.flatMainMenuToMenuItem[item.id] = {};
						}
						let _menuKey = moudleId+'.'+item.idInMenu;
						window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
						var isShow=false;   
      					var onlyQuery=false;
      					var visible=item.Properties.Visible.V;
      					if(visible!='false'){
							  if(window.userInfos.isAdmin)
							  {
								isShow = true;
							  }
							  else
							  {
	      						var thisAu=moudleId+'.'+item.idInMenu;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							
									if(!authorityArr.del && !authorityArr.visible && !authorityArr.query)
									{
										onlyQuery = true;
									}
									else if(!authorityArr.del && authorityArr.query)
									{
										isShow = true;onlyQuery = true;
									}
									else if(authorityArr.del || authorityArr.query)
									{
										isShow = true;
									}
				      			}
				      		}
      					}
      					
      					
                        if(isShow)
                        {
							var label=this.getLabelName(item);
							var _iclsName = "iconfont icon-liebiao";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
							if(iconPro)
							{
								_iclsName = iconPro;	
							}
							let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
							content.push(
								<li key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V} >
									<a  className="listtree-menu-title" onClick={this.menuItemClick} title={label}  data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={onlyQuery}>
										<div className="listtree-menu-title-div" >
											<div className={"listtree-menu-icon "+_iclsName}></div>
											<span class="listtree-menu-text">{label}</span>
										</div>
									</a>
								</li>
							);
							let menuItemKey = item.id+"."+item.idInMenu;
	      					item.onlyQuery = onlyQuery;
	      					this.platMainMenu[menuItemKey] = item;
                        }
      					
      					
      				}else if(item.qname=="MenuSub")
      				{	
      					
      					var isShow=false; 
      					var visible=item.Properties.Visible.V;
      					if(visible=='true'){
      						if(window.userInfos.isAdmin){
	      						isShow=true;
	      					} else{
	      						var thisAu=moudleId+'.'+item.id;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      								isShow=false;
	      							}else{
	      								isShow=true;
	      							}
	      						}
	      					}
      					}
      					
      					
						  if(isShow)
						  {
							var label=this.getLabelName(item);
							var _clsName = "iconfont icon-liebiao";
							var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
											//|| GOTUtil.getPropertyValue(item,"HasIcon")
							if(iconPro)
							{
								_clsName = iconPro;
								content.push(
									<li className="listtree-has-children" key={'listtree'+i}>
										<a className="listtree-menu-title" >
											<div  className="listtree-menu-title-div" >
												<div className={"listtree-menu-icon "+_clsName}></div>
												<span className="listtree-menu-text">{label}</span>
												<span className="listtree-menu-arrow fa"></span>
											</div>
										</a>
										<ul className="listtree-menu-submenu">
											{this.renderSub(item.items,moudleId)}
										</ul>
									</li>
								);
							}
							else
							{
								content.push(
									<li className="listtree-has-children" key={'listtree'+i}>
										<a className="listtree-menu-title" >
											<i className={"listtree-menu-icon "+_clsName}></i>
											<span className="listtree-menu-text">{label}</span>
											<span className="listtree-menu-arrow fa"></span>
										</a>
										<ul className="listtree-menu-submenu">
											{this.renderSub(item.items,moudleId)}
										</ul>
									</li>
								);
							}
							
      					}
      				}
      			}
      			else
      			{	
      				var isShow=false; 
      				var visible=item.Properties.Visible.V;
      				if(visible=='true'){
      					if(window.userInfos.isAdmin){
		      				isShow=true;
		      			}else{
		      				moudleId=item.id; 
			      			var authorityArr=window.xmlType0SCache[moudleId];
			      			if(authorityArr){
			      				if(authorityArr.del){
			      					isShow=true;
			      				}else{
			      					isShow=false;
			      				}
			      			}
		      			}
      				}
      				
      				
                      if(isShow)
                      {
						var label=this.getLabelName(item); 
						var _clsName = "iconfont icon-liebiao";
						var iconPro = GOTUtil.getPropertyValue(item,"Icon");
						if(iconPro)_clsName = iconPro;
      					content.push(
                            <li className="listtree-has-children" key={'listtree'+i}>
                                <a className="listtree-menu-title" >
                                    <i  className={"listtree-menu-icon "+_clsName}></i> 
                                    <span className="listtree-menu-text">{label}</span>
                                    <span className="listtree-menu-arrow fa"></span>
                                </a>
                                <ul className="listtree-menu-submenu">
                                    {this.renderSub(item.items,moudleId)}
                                </ul>
                            </li>
      					);
      				}

      			}
			}
		}
		return content;
	}

	renderCustomMenu(mainContent)
	{
		if(!window.userSettingEntryOrig.menuCustomObject)
			return;
		let i = mainContent.length;
		if(i==0)
			return;
		let _menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
		let num = 0;
		for(let key in _menuCustomObject.customItems)
		{
			num++;
		}
		if(num == 0)return;
		let _clsName = "iconfont icon-yingyong";
		mainContent.unshift(
	        <li className="listtree-has-children" key={'listtree'+i}>
	            <a className="listtree-menu-title">
	                <i   className={"listtree-menu-icon "+_clsName}></i> 
	                <span className="listtree-menu-text">常用菜单</span>
	                <span className="listtree-menu-arrow fa"></span>
	            </a>
	            <ul className="listtree-menu-submenu">
	                {this.renderCustomMenuSub()}
	            </ul>
	        </li>
		);
	}

	renderCustomMenuSubSub(groupKey,groupItem)
	{
		let content = [];let i = 0;
		if(!groupKey)
			return content;
		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId != groupKey)
				continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				/*var _clsName = "iconfont icon-default text-blue";
				var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
				if(iconPro)_clsName = iconPro;
				content.push(
					<li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
						<a title={label} style={{cursor:"pointer",display:'flex',alignItems:'center',paddingTop:'1px',paddingBottom:'1px'}} onClick={this.menuItemClickSelect} onDoubleClick={this.menuItemClick} data-formId={item.Properties.RefObject.refentityid} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
							<i className={_clsName} style={{flexShrink:0,marginRight:'4px',marginTop:'2px',fontSize:'14px'}}></i> 
							<div>{label}</div>
						</a>
					</li>
				);*/
				var _iclsName = "iconfont icon-liebiao";
				var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
				if(iconPro)
				{
					_iclsName = iconPro;	
				}
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
				content.push(
					<li key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
						<a  className="listtree-menu-title" onClick={this.menuItemClick} title={label}  data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
							<div className='listtree-menu-title-div' >
								<div className={"listtree-menu-icon "+_iclsName}></div>
								<span className="listtree-menu-text">{label}</span>
							</div>
						</a>
					</li>
				);
				i++;
			}
		}
		return content;
	}

	renderCustomMenuSub()
	{
		let content = [];let i = 0;let k = 0;

		for(let groupKey in window.userSettingEntryOrig.menuCustomObject.groups)
		{
			var groupItem = window.userSettingEntryOrig.menuCustomObject.groups[groupKey];
			var label=groupItem.name;
			var _clsName = "fa fa-bars";
			content.push(
				<li className="listtree-has-children" key={'listtree'+k}>
					<a className="listtree-menu-title" >
						<i className={"listtree-menu-icon "+_clsName}></i>
						<span className="listtree-menu-text">{label}</span>
						<span className="listtree-menu-arrow fa"></span>
					</a>
					<ul className="listtree-menu-submenu">
						{this.renderCustomMenuSubSub(groupKey,groupItem)}
					</ul>
				</li>
			);
			k++;
			/*var _clsName = "fa fa-bars text-blue";
			
			content.push(
				<li className="treeview menuSub">
					<a style={{cursor:"pointer"}}>
						<i className={_clsName}></i> 
						<span>{label}</span>
						<span className="pull-right-container">
							<i className="fa fa-angle-left pull-right"></i>
						</span>
					</a>
					<ul className="treeview-menu">
						{this.renderCustomMenuSubSub(groupKey,groupItem)}
					</ul>
				</li>
			);*/
		}

		for(let key in window.userSettingEntryOrig.menuCustomObject.customItems)
		{
			let customItem = window.userSettingEntryOrig.menuCustomObject.customItems[key];
			if(customItem.groupId)continue;
			if(this.platMainMenu.hasOwnProperty(key))
			{
				let item = this.platMainMenu[key];
				var label=this.getLabelName(item);
				var _iclsName = "iconfont icon-liebiao";
				var iconPro = GOTUtil.getPropertyValue(item,"Icon") || GOTUtil.getPropertyValue(item,"HelpText");
				if(iconPro)
				{
					_iclsName = iconPro;	
				}
				let dataFormId = item.Properties.RefObject?item.Properties.RefObject.refentityid:item.Properties.Source.refentityid;
				content.push(
					<li key={'menuItem-li'+i} data-formLabel={item.Properties.Label.V}>
						<a  className="listtree-menu-title" onClick={this.menuItemClick} title={label}  data-formId={dataFormId} data-formLabel={label} data-menuItemId={item.id} data-onlyQuery={item.onlyQuery}>
							<div className='listtree-menu-title-div' >
								<div className={"listtree-menu-icon "+_iclsName}></div>
								<span className="listtree-menu-text">{label}</span>
							</div>
						</a>
					</li>
				);
				i++;
			}
		}
		return content;
	}
	
	rederUserDataSettings(mainContent,dataSettings,index){
		if (window.rightSidebarClicked)return;
		let i = mainContent.length;
		if(i==0)return;
		let _clsName = "iconfont icon-kaoheweidufenxi";

		mainContent.unshift(
			<li className="listtree-has-children" key={'listtree'+(index+1)}>
			<a className="listtree-menu-title">
				<i className={"listtree-menu-icon "+_clsName}></i> 
				<span className="listtree-menu-text">数据集</span>
				<span className="listtree-menu-arrow fa"></span>
			</a>
			<ul className="listtree-menu-submenu">
				{dataSettings}
			</ul>
		</li>
		
	  );
	}

	render()
	{
		let mainMenu=this.props.data;
		let dataSettings = this.props.dataSettings;
		var moudleId;
		let mainContent=this.renderSub(mainMenu.items,moudleId);
		this.renderCustomMenu(mainContent);
		if(dataSettings){
			this.rederUserDataSettings(mainContent,dataSettings,mainMenu.items.length);
		}
		//TODO MainMenu的Label不显示 <li className="header">{mainMenu.Properties.Label.V}</li>
		return(
			<ul className="listtree-menu" >
        		{mainContent}
        	</ul>
		);

    }
}






// WEBPACK FOOTER //
// ./src/components/menu/ListTreeViewMainMenu.js